import { CloseOutlined } from '@ant-design/icons';
import styles from './style.module.scss';
import { Typography } from 'antd';

const FilterWrapper = ({ children, title, onClose, hideClose = false }) => {
  return (
    <div className={styles.wrapper}>
      <Typography.Text className={styles.title}>{title}</Typography.Text>
      {children}
      {!hideClose && (
        <CloseOutlined className={styles.closeIcon} onClick={onClose} />
      )}
    </div>
  );
};

export default FilterWrapper;
